<template>
  <table :id="tableId" class="table table-bordered table-striped">
    <thead>
      <tr>
        <th v-for="c in columns"> {{ c.label }}</th>
      </tr>
    </thead>
  </table>
</template>

<script>
export default {
  props: ['tableId', 'url', 'columnDefs', 'columns', 'order'],
  mounted () {
    let dtColumns = []
    for (var el in this.columns) {
      dtColumns.push({ data: this.columns[el].field })
    }
    $('#' + this.tableId).DataTable({
      processing: true,
      serverSide: true,
      order: this.order ? this.order : [[0, 'asc']],
      ajax: {
        url: this.url,
        data: function (d) {
          return {
            limit: d.length,
            offset: d.start,
            search: d.search.value ? d.search.value : null,
            orderBy: d.columns[d.order[0]['column']].data,
            orderDirection: d.order[0].dir
          }
        },
        dataFilter: function (response) {
          response = JSON.parse(response)

          let total = response.total
          delete response['total']

          let elements = Object.values(response)
          elements.splice(-1, 1)

          var fd = {
            data: elements,
            recordsTotal: total,
            recordsFiltered: total
          }
          return JSON.stringify(fd)
        }
      },
      columnDefs: this.columnDefs,
      columns: dtColumns
    })
  }
}
</script>



// WEBPACK FOOTER //
// DataTables.vue?aa0c7020